import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { setShowPaymentModal } from '../../../actions'
import { ACCOUNT_STATUS } from '../../../constants'
import { getMergedPlan } from '../../../constants/plans'
import styles from './SubscriptionSuspendedModal.module.css'

function SubscriptionSuspendedModal({ profile }) {
  const dispatch = useDispatch()
  // Hide while the payment modal is open so the two modals don't stack
  const showPaymentModal = useSelector((s) => s.upgrade.showPaymentModal)

  const isSuspended = profile?.status?.toUpperCase() === ACCOUNT_STATUS.SUSPENDED

  if (!isSuspended || showPaymentModal) return null

  const period = profile?.interval === 'month' ? 'monthly' : 'yearly'
  const plan = profile?.productId ? getMergedPlan(profile.productId, profile.currency) : null
  const planName = plan?.label || 'your plan'
  const priceData = plan?.prices?.[period]
  const price = priceData?.value ? `${priceData.symbol || '$'}${priceData.value}` : null

  const handleResubscribe = () => {
    dispatch(
      setShowPaymentModal({
        showPaymentModal: true,
        upgradePlanId: profile.productId,
        periodProp: period
      })
    )
  }

  const handleContactSupport = () => window.$crisp?.push(['do', 'chat:open'])

  return (
    <Modal show backdrop="static" keyboard={false} centered dialogClassName={styles.dialog}>
      <Modal.Body className={styles.body}>
        <div className={styles.iconRow}>
          <img src="/assets/icons/warning_black.svg" height={28} width={28} alt="warning" />
        </div>

        <h4 className={styles.title}>Your account has been suspended</h4>

        <p className={styles.description}>
          We were unable to collect payment for your subscription. Re-subscribe below to restore access to your account
          and all your sites.
        </p>

        <div className={styles.planBox}>
          <div className={styles.planName}>{planName}</div>
          {price && (
            <div className={styles.planPrice}>
              {price} /{period}
            </div>
          )}
        </div>

        <Button className={`w-100 mt-4 ${styles.payBtn}`} onClick={handleResubscribe}>
          Re-subscribe
        </Button>

        <p className={styles.hint}>You will be asked to enter your card details on the next screen.</p>

        <p className={styles.hint}>
          Need help instead,{' '}
          <button type="button" className={styles.supportLink} onClick={handleContactSupport}>
            Contact support?
          </button>
        </p>
      </Modal.Body>
    </Modal>
  )
}

export default SubscriptionSuspendedModal
